import { SharedoFetch } from "@sharedo/mobile-core";

const getTree = () => SharedoFetch.get("/api/sharedoTypes/tree");

export default {
    getTree
}